import { render } from "./ExpertLabelSection.vue?vue&type=template&id=1fc5df59&scoped=true"
import script from "./ExpertLabelSection.vue?vue&type=script&lang=js"
export * from "./ExpertLabelSection.vue?vue&type=script&lang=js"

import "@/assets/css/labelSection.sass?vue&type=style&index=0&id=1fc5df59&lang=sass&scoped=true"
import "@/assets/css/essayWriting.sass?vue&type=style&index=1&id=1fc5df59&lang=sass&scoped=true"
import "./ExpertLabelSection.vue?vue&type=style&index=2&id=1fc5df59&scoped=true&lang=css"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc5df59"]])

export default __exports__